module.exports = __webpack_public_path__ + "static/media/japan_002.8677af53.jpg";